"use strict";

exports.intSub = function (x) {
  return function (y) {
    /* jshint bitwise: false */
    return x - y | 0;
  };
};

exports.numSub = function (n1) {
  return function (n2) {
    return n1 - n2;
  };
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Data/Ring.js
// module id = 87
// module chunks = 0